export enum HygienizationStatusEnum {
    higienizado = 1,
    nao_higienizado = 2,
    em_higienizacao = 3,
    em_uso = 4,
}